import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';

import { ApplicationParams } from 'types/route_params';

import { useAccessTokens } from 'hooks/api/useAccessTokens';
import { useAccount } from 'hooks/api/useAccount';
import { useApplication } from 'application/hooks/useApplication';
import { useAPI } from 'hooks/api/useAPI';
import { useFilesSearchClient } from 'files/hooks/useFilesSearchClient';
import { useHasAccess } from 'hooks/useHasAccess';

import { DashboardView } from 'dashboards/views/DashboardView/DashboardView';
import { Loader } from 'components/Loader/Loader';
import { NotFound } from 'views/NotFound/NotFound';

import { AppNotFound } from '../App/AppNotFound';

export function Embed() {
  const { applicationID } = useParams<ApplicationParams>();
  const { setApplicationID } = useAPI();
  const { error, isLoading } = useApplication(applicationID);
  const [hasAccess] = useHasAccess();
  const { data: account } = useAccount();

  const accountId = account?.id;

  const hasApplicationError =
    error && (error.status === 404 || error.status === 401);

  // Pre-load
  useAccessTokens();
  useFilesSearchClient();

  React.useEffect(() => {
    if (isLoading || hasApplicationError || !applicationID) {
      return;
    }

    setApplicationID(applicationID);
  }, [isLoading, hasApplicationError, applicationID, setApplicationID]);

  if (isLoading) {
    return <Loader text="Loading your workspace..." showLogo />;
  }

  if (!accountId) {
    return;
  }

  if (hasApplicationError) {
    return <AppNotFound />;
  }

  return (
    <Routes>
      {hasAccess('monitor') && (
        <Route
          path="monitor/dashboards/:dashboardID/*"
          element={<DashboardView />}
        />
      )}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
